var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-component"},[_c(_vm.tag,{tag:"component",style:(_vm.$vuetify.breakpoint.xsOnly ? _vm.mobStyleObject : _vm.styleObject)},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }